import React, {useRef, useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import BaseSimpleItemEditor from "../BaseSimplePage/BaseSimpleItemEditor";
import EventDraftsItemBrowser from "./EventDraftsItemBrowser";
import EventsMuseumItemForm from "../EventsMuseumPage/EventsMuseumItemForm";
import EventDraftsDraftItemForm from "./EventDraftsDraftItemForm";
import styles from "../BaseSimplePage/BaseSimpleItemEditorFooter.module.css";
import {Divider} from "@mui/material";
import BaseSimpleItemEditorFooterButton from "../BaseSimplePage/BaseSimpleItemEditorFooterButton";
import EventDraftsNewEventItemEditor from "./EventDraftsNewEventItemEditor";
import ServerManager from "../../API/ServerManager";

const EventDraftsPage = ({isAddSubMode}) => {

    // section names: drafts, events
    const [sectionsState, setSectionsState] = useState({
        drafts: getSectionInitialState(),
        events: getSectionInitialState(),
    });

    const [editorKey, setEditorKey] = useState(0);
    const [isCreationMode, setIsCreationMode] = useState(false);
    const [creationDraftId, setCreationDraftId] = useState(0);
    const [deleteConfirmDialogOpen, setDeleteConfirmDialogOpen] = useState(false)
    const [deleteDraftId, setDeleteDraftId] = useState(0)

    const itemBrowserRef = useRef(null);

    // TODO: можно сделать глобальными? обрабатывать в корневом компоненте?
    const [loadingOverlayData, setLoadingOverlayData] = useState(null); // { title }
    const [snackbarData, setSnackbarData] = useState(null); // { severity, title, message }
    const [confirmDialogData, setConfirmDialogData] = useState(null); // { message, confirmLabel, cancelLabel, onAnswer }

    const handleErrorSnackbarClose = (event, reason) => {
        setSnackbarData(null);
    };

    function renderItemEditor(key, props) {
        return <BaseSimpleItemEditor {...props} key={key}/>
    }

    function onSectionItemSelect(sectionName, selectedId) {
        const otherSectionName = sectionName === "drafts" ? "events" : "drafts";
        setSectionsState(prev => ({
            ...prev,
            [sectionName]: {...prev[sectionName], selectedItemId: selectedId},
            [otherSectionName]: {...prev[otherSectionName], selectedItemId: 0},
        }));
        setIsCreationMode(false);
    }

    function renderDraftEditorFooter(props) {
        return (
            <div className={styles.main}>
                <Divider component="div"/>
                <div className={styles.buttonsArea}>
                    <BaseSimpleItemEditorFooterButton
                        label="Перейти к созданию события"
                        onClick={() => {
                            setIsCreationMode(true);
                            setCreationDraftId(sectionsState.drafts.selectedItemId);
                            setEditorKey(prev => prev + 1);
                            setSectionsState(prev => ({
                                ...prev,
                                drafts: {...prev.drafts, selectedItemId: 0},
                                events: {...prev.events, selectedItemId: 0},
                            }));
                        }}
                    />
                    <BaseSimpleItemEditorFooterButton
                        label="Удалить заявку"
                        onClick={() => {
                            setDeleteDraftId(sectionsState.drafts.selectedItemId);
                            setDeleteConfirmDialogOpen(true);
                        }}
                    />
                </div>
            </div>
        );
    }

    async function handleAdd(data) {
        setLoadingOverlayData({title: "Добавление записи"});

        let addedId = 0;

        try {
            const responseData = await ServerManager.addSimpleModeItem("event", {...data, draft_id: creationDraftId});
            addedId = responseData.id;
            console.log("addedId", addedId);
        } catch (error) {
            setLoadingOverlayData(null);
            setSnackbarData({severity: "error", title: "Ошибка при добавлении записи!", message: error});
            return;
        }

        // успешно добавлено

        try {
            itemBrowserRef.current.refreshItems();
        } catch (error) {
            // nothing //
        }

        setLoadingOverlayData(null);
        setSnackbarData({severity: "success", message: "Запись добавлена"});
        setEditorKey(editorKey + 1);

        setIsCreationMode(false);
        setCreationDraftId(0);
    }

    async function performDeleteDraft() {
        setLoadingOverlayData({title: "Удаление заявки"});

        let deleted = false;

        try {
            const response = await ServerManager.deleteEventDraft(deleteDraftId);
            deleted = true;
        } catch (error) {
            setSnackbarData({severity: "error", title: "Ошибка при удалении заявки!", message: error});
        }

        setLoadingOverlayData(null);

        if (deleted) {

            try {
                itemBrowserRef.current.refreshItems();
            } catch (error) {
                // nothing //
            }

            setSnackbarData({severity: "success", message: "Заявка удалена"});
            setEditorKey(editorKey + 1);
            setDeleteDraftId(0);
            setSectionsState(prev => ({
                ...prev,
                drafts: {...prev.drafts, selectedItemId: 0},
                events: {...prev.events, selectedItemId: 0},
            }));
        }
    }

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                <div className={cl.browserArea} style={{width: "min(35%, 460px)", minWidth: "310px"}}>
                    <EventDraftsItemBrowser
                        ref={itemBrowserRef}
                        sectionsState={sectionsState}
                        setSectionsState={setSectionsState}
                        onSectionItemSelect={onSectionItemSelect}
                        setSnackbarData={setSnackbarData}
                    />
                </div>
                {(!isCreationMode && (sectionsState.drafts.selectedItemId !== 0 || sectionsState.events.selectedItemId !== 0)) &&
                    <div className={cl.editorArea}>
                        {renderItemEditor(sectionsState.drafts.selectedItemId + "|" + sectionsState.events.selectedItemId + "|" + editorKey, {
                            modeApiName1: sectionsState.drafts.selectedItemId !== 0 ? "event-draft" : "event",
                            ItemFormComponent: sectionsState.drafts.selectedItemId !== 0 ? EventDraftsDraftItemForm : EventsMuseumItemForm,
                            isAddSubMode: false,
                            editItemId: sectionsState.drafts.selectedItemId !== 0 ? sectionsState.drafts.selectedItemId : sectionsState.events.selectedItemId,
                            searchByIdMode: false,
                            onAdd: null,
                            onDelete: null,
                            onSave: null,
                            setSnackbarData: setSnackbarData,
                            setLoadingOverlayData: setLoadingOverlayData,
                            pageOptions: {},
                            testReadOnlyFunc: () => true,
                            renderFooterFunc: sectionsState.drafts.selectedItemId !== 0 ? renderDraftEditorFooter : () => null,
                            headerCustomTextFunc: (isAddSubMode, editItemId) => {
                                return  sectionsState.drafts.selectedItemId !== 0 ? `Просмотр заявки (id=${editItemId})` : `Просмотр события в базе (id=${editItemId})`;
                            }
                        })}
                    </div>}
                {(isCreationMode && <EventDraftsNewEventItemEditor
                    key={editorKey}
                    setSnackbarData={setSnackbarData}
                    setLoadingOverlayData={setLoadingOverlayData}
                    sourceDraftId={creationDraftId}
                    onAdd={handleAdd}
                />)}
            </div>
            {snackbarData && <AlertSnackbar
                open={true}
                severity={snackbarData.severity}
                title={snackbarData.title}
                message={snackbarData.message}
                onClose={handleErrorSnackbarClose}
            />}
            {loadingOverlayData && <LoadingOverlay
                open={true}
                title={loadingOverlayData.title}
            />}
            {confirmDialogData && <ConfirmDialog
                open={true}
                message={confirmDialogData.message}
                confirmLabel={confirmDialogData.confirmLabel}
                cancelLabel={confirmDialogData.cancelLabel}
                onAnswer={confirmDialogData.onAnswer}
            />}
            <ConfirmDialog
                open={deleteConfirmDialogOpen}
                fullWidth={true}
                maxWidth={"xs"}
                message="Удалить заявку?"
                confirmLabel="Да"
                cancelLabel="Нет"
                onAnswer={confirmed => {
                    setDeleteConfirmDialogOpen(false);
                    if (confirmed)
                        performDeleteDraft();
                }}
            />
        </div>
    );
};

function getSectionInitialState() {
    return {
        filteredItems: [],
        refsData: {},
        selectedItemId: 0,
    };
}

export default EventDraftsPage;